var jvc_RM_C1100 = {
    name: "RM_C1100",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,213,188,128],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,245,121],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,223,114],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,239,114],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,215,185],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,247,114],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,219,185],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,235,185],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,213,220,128],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,251,114],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,221,185],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,254,228],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,247,228],
        },
        {
            function: "standard",
            name: "standard",
            icon: "standard",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,221,86,64],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,250,174,64],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [34,0,3,0,2,95,6,0,2,47,2,1,2,130,91,213,173,245,32],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [34,0,3,0,2,95,6,0,2,47,2,1,2,130,91,213,171,245,32],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [34,0,3,0,2,95,6,0,2,47,2,1,2,130,91,213,175,234,64],
        },
        {
            // function: "pr_up",
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,221,121],
        },
        {
            // function: "pr_dn",
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,250,242],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,213,94,64],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,234,188,128],
        },
        {
            // function: "av",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,215,121],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,95,237,86,64],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,235,188,128],
        },
        {
            function: "txt_resize",
            name: "txt_resize",
            icon: "txt_resize",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,254,185],
        },
        {
            function: "hint",
            name: "hint",
            icon: "hint",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,251,242],
        },
        {
            function: "hold",
            name: "hold",
            icon: "hold",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,239,121],
        },
        {
            function: "KEY_TIME",
            name: "KEY_TIME",
            icon: "KEY_TIME",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,247,242],
        },
        {
            function: "hide",
            name: "hide",
            icon: "hide",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,237,188,128],
        },
        {
            function: "index",
            name: "index",
            icon: "index",
            command: [34,0,3,0,2,47,2,0,2,95,6,1,2,130,91,94,245,249],
        },
    ]
}
export default jvc_RM_C1100